import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession, getReturnPath } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash (using location.hash for reactivity)
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        // Clean the URL immediately
        window.history.replaceState(null, '', window.location.pathname);
        
        // Exchange session_id for user data
        const user = await exchangeSession(sessionId);
        
        // Get the path to return to (e.g., /booking)
        const returnPath = getReturnPath();
        
        if (user) {
          // Navigate to return path (or home) with user data
          navigate(returnPath, { state: { user }, replace: true });
        } else {
          // Auth failed, go to home
          navigate('/', { replace: true });
        }
      } else {
        // No session_id, redirect to home
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [location.hash, exchangeSession, navigate, getReturnPath]);

  // Silent processing - no loading UI shown
  return null;
}
